import { FormFields, FormValidationSchema } from '@/common/interfaces';

export enum DnsRecordFormInputs {
  Name = 'name',
  Records = 'records',
  Record = 'record',
  ApiProvider = 'apiProvider',
  ApiProviderAccountId = 'apiProviderAccountId',
}

export type DnsRecordFormFields = FormFields<typeof DnsRecordFormInputs>;

export type DnsRecordFormValidationSchema = FormValidationSchema<DnsRecordFormFields>;
